<script>
export default {
  name: "album-page",
  data() {
    return {
      showLarge: true,
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      if (window.innerWidth <= 480) {
        this.showLarge = false;
      } else {
        this.showLarge = true;
      }
    }
  }
}
</script>

<style scoped>

</style>